import React from 'react';

import { stripDomainForMedia } from 'src/util/sanitizeLink';

import { getAdvancedSettings } from '../advancedSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import type { HtmlType } from './htmlConfigAggregator';

type PageBuilderHtmlProps = HtmlType;

/**
 * Return the PB Html
 * @param props
 * @constructor
 */
export function PageBuilderHtml(props: PageBuilderHtmlProps) {
    /**
     * Configure the styles requires for the Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderHtmlProps>(props);

    const htmlClassNames = ['pageBuilderHtmlGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        htmlClassNames.push(...props.cssClasses);
    }

    const toHTML = (str) => {
        const fns = [stripDomainForMedia];
        return { __html: fns.reduce((acc, fn) => fn(acc), str) };
    };

    /**
     * Render the HTML Block UI
     */

    return (
        <PageBuilderElementWrapper
            contentType={props.contentType}
            uniqueID={props.uniqueID}
            styles={advancedSettings}
            classNames={htmlClassNames}
        >
            <div dangerouslySetInnerHTML={toHTML(props.html)} />
        </PageBuilderElementWrapper>
    );
}
